// channelTypes.js

export const CHANNEL_TYPES = Object.freeze({
  TEXT: 'TEXT',
  VOICE_VIDEO: 'VOICE_VIDEO',
});

const normalizeChannelTypeValue = (value) => String(value || '').trim().toUpperCase();

export const normalizeChannelType = (value) => {
  const normalized = normalizeChannelTypeValue(value);

  if (normalized === CHANNEL_TYPES.VOICE_VIDEO) {
    return CHANNEL_TYPES.VOICE_VIDEO;
  }

  return CHANNEL_TYPES.TEXT;
};

export const isVoiceVideoChannel = (value) => normalizeChannelType(value) === CHANNEL_TYPES.VOICE_VIDEO;

export const getChannelTypeLabel = (value) => {
  if (isVoiceVideoChannel(value)) {
    return 'Voice / Video';
  }

  return 'Text Chat';
};
